import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BottomSheet from "Trackalyze/BottomSheet";

import Filter from "./Filter";

const FilterWrapperPortrait = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(true);
  const [targetNode, setTargetNode] = useState(null);

  useEffect(() => {
    setTargetNode(document.getElementById("app"));
  }, []);

  const handleClose = () => setIsOpen(false);
  const handleAfterClose = () => navigate(-1);

  if (!targetNode) return null;

  return createPortal(
    <BottomSheet animate={isOpen} onAfterAnimate={handleAfterClose}>
      <Filter
        portrait
        onClose={handleClose}
        activeFilter={searchParams.get("type")}
      />
    </BottomSheet>,
    targetNode
  );
};

export default FilterWrapperPortrait;
